import React, { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import { ReactComponent as IconCheck } from "../../../../icons/16x16/check.svg";
import { ReactComponent as IconTrash } from "../../../../icons/16x16/trash.svg";
import { ReactComponent as IconX } from "../../../../icons/16x16/x.svg";
import { isLargeSize, isSmallSize } from "../../../../utils/customization/device";
import ButtonSmily from "../../../atoms/ButtonSmily";
import Link from "../../../atoms/Link";
import "./style.scss";

type ValidationType = "error" | "primary";

interface Props {
  feedback?: string;
  onCancel: () => void;
  onValidate: () => void;
  validateButton?: { disabled: boolean; label: string; type: ValidationType };
}

const ValidationHeader: FunctionComponent<Props> = ({
  feedback,
  onCancel,
  onValidate,
  validateButton,
}) => {
  const intl = useIntl();

  const validationType: ValidationType = (validateButton && validateButton.type) || "primary";

  return (
    <div className={`ValidationHeader ValidationHeader-${validationType}`}>
      {isSmallSize() ? (
        <Link onClick={onCancel} size="m">
          <IconX />
        </Link>
      ) : (
        <ButtonSmily onClick={onCancel} size={isLargeSize() ? "s" : "xs"} type="tertiary">
          {intl.formatMessage({ id: "kustom_ConfirmModal_cancel" })}
        </ButtonSmily>
      )}

      {feedback && <div className="ValidationHeader-feedback">{feedback}</div>}

      <ButtonSmily
        disabled={validateButton && validateButton.disabled === true}
        icon={validationType === "error" ? <IconTrash /> : <IconCheck />}
        iconPosition={isSmallSize() ? "alone" : "left"}
        onClick={onValidate}
        size={isLargeSize() ? "s" : "xs"}
        type="primary"
      >
        {!isSmallSize() &&
          ((validateButton && validateButton.label) ||
            intl.formatMessage({ id: "kustom_EditableBookTitle_validate" }))}
      </ButtonSmily>
    </div>
  );
};

export default ValidationHeader;
